@use "../../../sass/variables/colors";
@use "../../../sass/variables/typography";
@use "../../../sass/variables/z-index";
@use "../../../sass/mixins/font-family";

:host {
  @include font-family.font(bold);

  align-items: center;
  background: colors.$color-white;
  border: 2px solid colors.$color-gray-inactive;
  border-radius: 50%;
  color: colors.$color-gray-inactive;
  display: flex;
  flex: 0 0 auto;
  font-size: typography.$size-text-small;
  height: 30px;
  justify-content: center;
  margin-right: 50px;
  position: relative;
  width: 30px;
  z-index: z-index.$z-index-steps-item;

  @media only screen and (width >=768px) {
    border: 3px solid colors.$color-gray-inactive;
  }

  @media only screen and (width >=1024px) {
    margin-right: 110px;
  }

  &:last-child {
    margin-right: 0;
  }



  &::before {
    background: colors.$color-gray-inactive;
    content: "";
    height: 2px;
    left: -0.5px;
    position: absolute;
    transform: translateX(-100%);
    width: 51.5px;
    z-index: z-index.$z-index-steps-items-before;

    @media only screen and (width >=768px) {
      height: 3px;
      left: 0;
      width: 53.5px;
    }

    @media only screen and (width >=1024px) {
      width: 113px;
    }
  }

  @media (width >=576px) {

    font-size: typography.$size-text-normal;
    height: 42px;
    width: 42px;
  }

  @media (width >=1024px) {

    height: 50px;
    width: 50px;


    p {
      display: block;
      font-size: typography.$size-text-small;
    }
  }
}

p {
  @include font-family.font(bold);

  bottom: 0;
  color: colors.$color-gray-inactive;
  display: none;
  font-size: typography.$size-text-smaller;
  left: 50%;
  margin: 0;
  position: absolute;
  text-align: center;
  text-transform: uppercase;
  transform: translateX(-50%) translateY(calc(100% + 13px));
  width: 200%;

  @media only screen and (width >=1024px) {
    width: 300%;
  }

}

:host([done]) {
  background: colors.$color-green;
  border: 2px solid colors.$color-green;
  color: colors.$color-white;

  @media only screen and (width >=768px) {
    border: 3px solid colors.$color-green;
  }

  &::before {
    background: colors.$color-green;
  }

  ux-icon {
    fill: colors.$color-white;
  }

  p {
    color: colors.$color-green;
  }
}

:host([active]) {
  background: colors.$color-white;
  border: 2px solid colors.$color-green;
  color: colors.$color-green;

  @media (width >=768px) {
    border: 3px solid colors.$color-green;
  }

  &::before {
    background: colors.$color-green;
  }

  p {
    color: colors.$color-green;
  }
}

:host(:first-of-type) {
  &:before {
    display: none;
  }
}